import en from './languages/en';
import de from './languages/de';
import { isInAppBrowser } from './helpers/device';

const config: CVT.Config = {
  projectName: 'BeyonDegrees',
  featureFlags: {
    googleSSO: !isInAppBrowser,
    microsoftSSO: false,
    translations: false,
    notifications: true,
    darkMode: false,
    aiExplorerChat: false,
    signup: false,
    understandMatches: true,
  },
  theme: {
    defaultMode: 'light',
    drawerWidth: 240,
    disableRipple: true,
    elevation: 0,
  },
  language: {
    dictionaries: {
      en,
      de,
    },
    languageLabelMap: {
      en: 'English',
      de: 'Deutsche',
    },
    supportedLanguages: ['en', 'de'],
    defaultLanguage: 'en',
    defaultDictionary: en,
  },
  defaultPermissions: {
    users: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
      invite: true,
    },
    disciplines: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    majors: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    specializations: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    universities: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    assertions: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
  },
  dialogs: ['supportContact', 'resetAccount'],
};

export const continueToDesktopStorageKey = `${import.meta.env.VITE__CVT_PROJECT_KEY}-continue-to-desktop`;

export default config;
